import React, { useState } from 'react'
import { useTranslation } from 'i18n'
import ViewButton from 'images/inline/gallery/view-button.svg'
import PlayButton from 'images/inline/gallery/play-button.svg'
import MediaUploadThumbnail from './MediaUploadThumbnail'
import './GalleryItem.scss'

const getMediaType = uploadFile => {
  let mediaType = 'photo'
  let videoArray = ['mov', 'mp4', 'avi', 'MOV', 'MP4', 'AVI']
  if (videoArray.includes(uploadFile.split('.').pop())) {
    mediaType = 'video'
  }
  return mediaType
}

const GalleryItem = ({
  item,
  id,
  name,
  thumbnail,
  uploadFile,
  votes = 0,
  handleItemClick = function (id) {},
  onVoteClick = () => {},
  zeroVotesCopy = '',
  galleryWidth,
  hasVoting = false,
}) => {
  const { t } = useTranslation('gallery')
  const [voteCount, setVoteCount] = useState(votes)

  let mediaType = getMediaType(uploadFile)

  const handleVoteClick = itemId => {
    onVoteClick(itemId)
    setVoteCount(voteCount + 1)
  }

  const voteText =
    votes === 0 ? zeroVotesCopy : t('voteCount', { count: votes })

  return (
    <div
      className={`gallery-item ${mediaType ? `media-type-${mediaType}` : ''}`}
      style={{ '--flex-basis': `${100 / galleryWidth}%` }}
    >
      <div className="gallery-item__inside">
        <div className="gallery-item__image-area">
          <a
            className="gallery-item__image-area-clickable-zone"
            role="button"
            onClick={() => {
              handleItemClick(id)
            }}
          >
            <div className="gallery-item__image-icon">
              <ViewButton />
            </div>
            <div className="gallery-item__background-container">
              {thumbnail && <MediaUploadThumbnail thumbnail={thumbnail} mediaType={mediaType} />}

              {mediaType === 'video' && (
                <div className="gallery-item__video-button">
                  <PlayButton />
                </div>
              )}
            </div>

            <div className="gallery-item__submitter">
              {name && t('submittedBy', { name })}
            </div>
          </a>
        </div>
        <div className="gallery-item__bottom-area">
          {hasVoting && <div className="gallery-item__votes">{voteText}</div>}
          {hasVoting && (
            <div className="gallery-item__vote-button">
              {' '}
              <button
                className={`btn ${
                  !item.userVotedToday ? 'themed-button' : 'themed-secondary'
                }`}
                disabled={!item.userVotedToday ? false : true}
                onClick={() => {
                  handleVoteClick(id)
                }}
              >
                {!item.userVotedToday
                  ? t('vote')
                  : galleryWidth < 5
                  ? t('voteRecorded')
                  : t('voteRecordedShort')}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
export default GalleryItem
